var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "member-level-container" },
    [
      _c(
        "div",
        { staticClass: "table-section" },
        [
          _c("SchemaTablePage", {
            ref: "tablePageRef",
            attrs: {
              "layout-mode": "tab",
              columns: _vm.tableColumns,
              "default-query": _vm.defaultQuery,
              request: _vm.request,
              "build-params": _vm.buildParams,
              "parse-result": _vm.parseResult,
              "table-attrs": _vm.tableAttrs,
            },
            scopedSlots: _vm._u([
              {
                key: "table-header",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "actions" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: { click: _vm.handleAddLevel },
                          },
                          [_vm._v("新增会员等级")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: { click: _vm.handleVipRuleDesc },
                          },
                          [_vm._v("VIP等级规则说明")]
                        ),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "colMoney",
                fn: function ({ row, column }) {
                  return [
                    _vm._v(_vm._s(_vm._f("centsToYuan")(row[column.property]))),
                  ]
                },
              },
              {
                key: "colPayoutEachDayMax",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      _vm._s(_vm._f("centsToYuan")(row.payout_each_day_max))
                    ),
                  ]
                },
              },
              {
                key: "colVipCount",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handleViewMembers(row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(row.vip_count))]
                    ),
                  ]
                },
              },
              {
                key: "colUpdatedAt",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      _vm._s(
                        row.updated_at
                          ? new Date(row.updated_at).toLocaleString()
                          : "--"
                      )
                    ),
                  ]
                },
              },
              {
                key: "colActions",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.handleLevelConfig(row)
                          },
                        },
                      },
                      [_vm._v("等级配置")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.handleBonusConfig(row)
                          },
                        },
                      },
                      [_vm._v("红利配置")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "page-dialog center-dialog-no-footer",
          attrs: {
            visible: _vm.vipMemberDialogVisible,
            title: `VIP${_vm.selectedLevel.level} 会员列表`,
            width: "1200px",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.vipMemberDialogVisible = $event
            },
            closed: _vm.handleVipMemberDialogClosed,
          },
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.vipMemberList,
                border: "",
                stripe: "",
                size: "small",
                "max-height": 500,
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  resizable: false,
                  prop: "username",
                  label: "会员昵称",
                  "min-width": "150",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  resizable: false,
                  prop: "gold",
                  label: "钱包余额",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm._f("centsToYuan")(scope.row.gold)) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  resizable: false,
                  prop: "agent_status",
                  label: "代理状态",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(scope.row.agent_status === 0 ? "否" : "是") +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  resizable: false,
                  prop: "created_at",
                  label: "注册时间",
                  "min-width": "140",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              scope.row.created_at
                                ? new Date(
                                    scope.row.created_at
                                  ).toLocaleString()
                                : ""
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  resizable: false,
                  prop: "login_at",
                  label: "最后登录时间",
                  "min-width": "140",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              scope.row.login_at
                                ? new Date(scope.row.login_at).toLocaleString()
                                : ""
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "text-align": "right", "margin-top": "15px" } },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.vipMemberCurrentPage,
                  "page-sizes": [10, 20, 30, 50],
                  "page-size": _vm.vipMemberPageSize,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.vipMemberTotal,
                },
                on: {
                  "size-change": _vm.handleVipMemberSizeChange,
                  "current-change": _vm.handleVipMemberCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "page-dialog center-dialog",
          attrs: {
            visible: _vm.levelConfigDialogVisible,
            title: _vm.selectedLevel.id
              ? `会员等级配置 - VIP${_vm.selectedLevel.level}`
              : "新增会员等级",
            width: "480px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.levelConfigDialogVisible = $event
            },
            closed: _vm.handleLevelConfigDialogClosed,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "levelConfigFormRef",
              attrs: {
                model: _vm.levelConfigForm,
                rules: _vm.levelConfigRules,
                "label-position": "right",
                size: "small",
                "label-width": "164px",
              },
            },
            [
              _c(
                "el-row",
                [
                  !_vm.selectedLevel.id
                    ? _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "会员等级", prop: "level" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { placeholder: "请选择会员等级" },
                                  model: {
                                    value: _vm.levelConfigForm.level,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.levelConfigForm,
                                        "level",
                                        $$v
                                      )
                                    },
                                    expression: "levelConfigForm.level",
                                  },
                                },
                                _vm._l(
                                  _vm.availableLevelOptionsForAdd,
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "升级存款", prop: "exp" } },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                              },
                            },
                            [
                              _c("el-input-number", {
                                staticStyle: { flex: "1" },
                                attrs: {
                                  placeholder: "请输入",
                                  disabled: _vm.levelConfigForm.level === 0,
                                  controls: false,
                                  min: 0,
                                },
                                model: {
                                  value: _vm.levelConfigForm.exp,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.levelConfigForm, "exp", $$v)
                                  },
                                  expression: "levelConfigForm.exp",
                                },
                              }),
                              _c("span", { staticClass: "amount-unit" }, [
                                _vm._v(_vm._s(_vm._f("amountUnit")(""))),
                              ]),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "保级打码量", prop: "keep_lock_bet" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                              },
                            },
                            [
                              _c("el-input-number", {
                                staticStyle: { flex: "1" },
                                attrs: {
                                  disabled: _vm.levelConfigForm.level === 0,
                                  controls: false,
                                  min: 0,
                                  placeholder: "请输入",
                                },
                                model: {
                                  value: _vm.levelConfigForm.keep_lock_bet,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.levelConfigForm,
                                      "keep_lock_bet",
                                      $$v
                                    )
                                  },
                                  expression: "levelConfigForm.keep_lock_bet",
                                },
                              }),
                              _c("span", { staticClass: "amount-unit" }, [
                                _vm._v(_vm._s(_vm._f("amountUnit")(""))),
                              ]),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "升级打码量", prop: "lock_bet" } },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                              },
                            },
                            [
                              _c("el-input-number", {
                                staticStyle: { flex: "1" },
                                attrs: {
                                  disabled: _vm.levelConfigForm.level === 0,
                                  controls: false,
                                  min: 0,
                                  placeholder: "请输入",
                                },
                                model: {
                                  value: _vm.levelConfigForm.lock_bet,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.levelConfigForm,
                                      "lock_bet",
                                      $$v
                                    )
                                  },
                                  expression: "levelConfigForm.lock_bet",
                                },
                              }),
                              _c("span", { staticClass: "amount-unit" }, [
                                _vm._v(_vm._s(_vm._f("amountUnit")(""))),
                              ]),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "单日提款限制(次)",
                            prop: "payout_each_day_times",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                              },
                            },
                            [
                              _c("el-input-number", {
                                staticStyle: { flex: "1" },
                                attrs: {
                                  controls: false,
                                  min: 0,
                                  placeholder: "请输入",
                                },
                                model: {
                                  value:
                                    _vm.levelConfigForm.payout_each_day_times,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.levelConfigForm,
                                      "payout_each_day_times",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "levelConfigForm.payout_each_day_times",
                                },
                              }),
                              _c("span", { staticClass: "amount-unit" }, [
                                _vm._v("次"),
                              ]),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "单日提款限额",
                            prop: "payout_each_day_max",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                              },
                            },
                            [
                              _c("el-input-number", {
                                staticStyle: { flex: "1" },
                                attrs: {
                                  controls: false,
                                  min: 0,
                                  placeholder: "请输入",
                                },
                                model: {
                                  value:
                                    _vm.levelConfigForm.payout_each_day_max,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.levelConfigForm,
                                      "payout_each_day_max",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "levelConfigForm.payout_each_day_max",
                                },
                              }),
                              _c("span", { staticClass: "amount-unit" }, [
                                _vm._v(_vm._s(_vm._f("amountUnit")(""))),
                              ]),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "每日免手续费(笔数)",
                            prop: "payout_each_day_no_fee_count",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                              },
                            },
                            [
                              _c("el-input-number", {
                                staticStyle: { flex: "1" },
                                attrs: {
                                  controls: false,
                                  min: 0,
                                  placeholder: "请输入",
                                },
                                model: {
                                  value:
                                    _vm.levelConfigForm
                                      .payout_each_day_no_fee_count,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.levelConfigForm,
                                      "payout_each_day_no_fee_count",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "levelConfigForm.payout_each_day_no_fee_count",
                                },
                              }),
                              _c("span", { staticClass: "amount-unit" }, [
                                _vm._v("次"),
                              ]),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.levelConfigDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.handleLevelConfigSubmit },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "page-dialog center-dialog",
          attrs: {
            visible: _vm.bonusConfigDialogVisible,
            title: `等级红利配置 - VIP${_vm.selectedLevel.level}`,
            width: "720px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.bonusConfigDialogVisible = $event
            },
            closed: _vm.handleBonusConfigDialogClosed,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "bonusConfigFormRef",
              attrs: {
                model: _vm.bonusConfigForm,
                rules: _vm.bonusConfigRules,
                "label-position": "right",
                size: "small",
              },
            },
            [
              _c(
                "div",
                { staticClass: "bonus-section" },
                [
                  _c(
                    "div",
                    { staticClass: "section-title" },
                    [
                      _vm._v(" 每周红利 "),
                      _c("el-switch", {
                        staticStyle: { "margin-left": "10px" },
                        attrs: { "active-value": 1, "inactive-value": 2 },
                        model: {
                          value: _vm.bonusConfigForm.has_week_reward,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.bonusConfigForm,
                              "has_week_reward",
                              $$v
                            )
                          },
                          expression: "bonusConfigForm.has_week_reward",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.bonusConfigForm.has_week_reward === 1
                    ? _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "每周红利",
                                    prop: "week_reward",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "align-items": "center",
                                      },
                                    },
                                    [
                                      _c("el-input-number", {
                                        attrs: { controls: false, min: 0 },
                                        model: {
                                          value:
                                            _vm.bonusConfigForm.week_reward,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.bonusConfigForm,
                                              "week_reward",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "bonusConfigForm.week_reward",
                                        },
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "amount-unit" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm._f("amountUnit")(""))
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "发放条件: 近一周流水",
                                    prop: "week_reward_need_bet",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "align-items": "center",
                                      },
                                    },
                                    [
                                      _c("el-input-number", {
                                        attrs: { controls: false, min: 0 },
                                        model: {
                                          value:
                                            _vm.bonusConfigForm
                                              .week_reward_need_bet,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.bonusConfigForm,
                                              "week_reward_need_bet",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "bonusConfigForm.week_reward_need_bet",
                                        },
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "amount-unit" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm._f("amountUnit")(""))
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "打码倍数",
                                    prop: "week_reward_lock_multiple",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "align-items": "center",
                                      },
                                    },
                                    [
                                      _c("el-input-number", {
                                        attrs: { controls: false, min: 0 },
                                        model: {
                                          value:
                                            _vm.bonusConfigForm
                                              .week_reward_lock_multiple,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.bonusConfigForm,
                                              "week_reward_lock_multiple",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "bonusConfigForm.week_reward_lock_multiple",
                                        },
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "amount-unit" },
                                        [_vm._v("倍")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "有效期",
                                    prop: "week_reward_limit_type",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          model: {
                                            value:
                                              _vm.bonusConfigForm
                                                .week_reward_limit_type,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.bonusConfigForm,
                                                "week_reward_limit_type",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "bonusConfigForm.week_reward_limit_type",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("按天")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 2 } },
                                            [_vm._v("按小时")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c("el-input-number", {
                                        staticStyle: {
                                          "margin-left": "20px",
                                          width: "120px",
                                        },
                                        attrs: { controls: false, min: 1 },
                                        model: {
                                          value:
                                            _vm.bonusConfigForm
                                              .week_reward_limit_value,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.bonusConfigForm,
                                              "week_reward_limit_value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "bonusConfigForm.week_reward_limit_value",
                                        },
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "amount-unit" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.bonusConfigForm
                                                  .week_reward_limit_type === 1
                                                  ? "天"
                                                  : "小时"
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        color: "#f56c6c",
                                        "font-size": "12px",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " 注:所有VIP等级会同时修改有效期，已发放的红利不受修改影响 "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "bonus-section" },
                [
                  _c(
                    "div",
                    { staticClass: "section-title" },
                    [
                      _vm._v(" 每月红利 "),
                      _c("el-switch", {
                        staticStyle: { "margin-left": "10px" },
                        attrs: { "active-value": 1, "inactive-value": 2 },
                        model: {
                          value: _vm.bonusConfigForm.has_month_reward,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.bonusConfigForm,
                              "has_month_reward",
                              $$v
                            )
                          },
                          expression: "bonusConfigForm.has_month_reward",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.bonusConfigForm.has_month_reward === 1
                    ? _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "每月红利",
                                    prop: "month_reward",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "align-items": "center",
                                      },
                                    },
                                    [
                                      _c("el-input-number", {
                                        attrs: { controls: false, min: 0 },
                                        model: {
                                          value:
                                            _vm.bonusConfigForm.month_reward,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.bonusConfigForm,
                                              "month_reward",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "bonusConfigForm.month_reward",
                                        },
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "amount-unit" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm._f("amountUnit")(""))
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "发放条件: 近一月流水",
                                    prop: "month_reward_need_bet",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "align-items": "center",
                                      },
                                    },
                                    [
                                      _c("el-input-number", {
                                        attrs: { controls: false, min: 0 },
                                        model: {
                                          value:
                                            _vm.bonusConfigForm
                                              .month_reward_need_bet,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.bonusConfigForm,
                                              "month_reward_need_bet",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "bonusConfigForm.month_reward_need_bet",
                                        },
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "amount-unit" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm._f("amountUnit")(""))
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "打码倍数",
                                    prop: "month_reward_lock_multiple",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "align-items": "center",
                                      },
                                    },
                                    [
                                      _c("el-input-number", {
                                        attrs: { controls: false, min: 0 },
                                        model: {
                                          value:
                                            _vm.bonusConfigForm
                                              .month_reward_lock_multiple,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.bonusConfigForm,
                                              "month_reward_lock_multiple",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "bonusConfigForm.month_reward_lock_multiple",
                                        },
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "margin-left": "10px",
                                            color: "#606266",
                                          },
                                        },
                                        [_vm._v("倍")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "有效期",
                                    prop: "month_reward_limit_type",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          model: {
                                            value:
                                              _vm.bonusConfigForm
                                                .month_reward_limit_type,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.bonusConfigForm,
                                                "month_reward_limit_type",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "bonusConfigForm.month_reward_limit_type",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("按天")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 2 } },
                                            [_vm._v("按小时")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c("el-input-number", {
                                        staticStyle: {
                                          "margin-left": "20px",
                                          width: "120px",
                                        },
                                        attrs: { controls: false, min: 1 },
                                        model: {
                                          value:
                                            _vm.bonusConfigForm
                                              .month_reward_limit_value,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.bonusConfigForm,
                                              "month_reward_limit_value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "bonusConfigForm.month_reward_limit_value",
                                        },
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "amount-unit" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.bonusConfigForm
                                                  .month_reward_limit_type === 1
                                                  ? "天"
                                                  : "小时"
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        color: "#f56c6c",
                                        "font-size": "12px",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " 注:所有VIP等级会同时修改有效期，已发放的红利不受修改影响 "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "bonus-section" },
                [
                  _c(
                    "div",
                    { staticClass: "section-title" },
                    [
                      _vm._v(" 升级红利 "),
                      _c("el-switch", {
                        staticStyle: { "margin-left": "10px" },
                        attrs: { "active-value": 1, "inactive-value": 2 },
                        model: {
                          value: _vm.bonusConfigForm.has_reward,
                          callback: function ($$v) {
                            _vm.$set(_vm.bonusConfigForm, "has_reward", $$v)
                          },
                          expression: "bonusConfigForm.has_reward",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.bonusConfigForm.has_reward === 1
                    ? _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "升级红利", prop: "reward" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "align-items": "center",
                                      },
                                    },
                                    [
                                      _c("el-input-number", {
                                        attrs: { controls: false, min: 0 },
                                        model: {
                                          value: _vm.bonusConfigForm.reward,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.bonusConfigForm,
                                              "reward",
                                              $$v
                                            )
                                          },
                                          expression: "bonusConfigForm.reward",
                                        },
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "amount-unit" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm._f("amountUnit")(""))
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "打码倍数",
                                    prop: "reward_lock_multiple",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "align-items": "center",
                                      },
                                    },
                                    [
                                      _c("el-input-number", {
                                        attrs: { controls: false, min: 0 },
                                        model: {
                                          value:
                                            _vm.bonusConfigForm
                                              .reward_lock_multiple,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.bonusConfigForm,
                                              "reward_lock_multiple",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "bonusConfigForm.reward_lock_multiple",
                                        },
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "amount-unit" },
                                        [_vm._v("倍")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "有效期",
                                    prop: "reward_is_forever",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          model: {
                                            value:
                                              _vm.bonusConfigForm
                                                .reward_is_forever,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.bonusConfigForm,
                                                "reward_is_forever",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "bonusConfigForm.reward_is_forever",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("永久有效")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 2 } },
                                            [_vm._v("天")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 3 } },
                                            [_vm._v("小时")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm.bonusConfigForm.reward_is_forever !==
                                      1
                                        ? _c("el-input-number", {
                                            staticStyle: {
                                              "margin-left": "20px",
                                              width: "120px",
                                            },
                                            attrs: { controls: false, min: 1 },
                                            model: {
                                              value:
                                                _vm.bonusConfigForm
                                                  .reward_limit_value,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.bonusConfigForm,
                                                  "reward_limit_value",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "bonusConfigForm.reward_limit_value",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm.bonusConfigForm.reward_is_forever !==
                                      1
                                        ? _c(
                                            "span",
                                            { staticClass: "amount-unit" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.bonusConfigForm
                                                      .reward_is_forever === 2
                                                      ? "天"
                                                      : "小时"
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        color: "#f56c6c",
                                        "font-size": "12px",
                                      },
                                    },
                                    [_vm._v("注:所有VIP等级会同时修改有效期")]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.bonusConfigDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.handleBonusConfigSubmit },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "page-dialog center-dialog",
          attrs: {
            visible: _vm.vipRuleDescDialogVisible,
            title: "VIP等级规则说明",
            width: "600px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.vipRuleDescDialogVisible = $event
            },
            closed: _vm.handleVipRuleDescDialogClosed,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "vipRuleDescFormRef",
              attrs: {
                model: _vm.vipRuleDescForm,
                rules: _vm.vipRuleDescRules,
                "label-position": "right",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "规则说明" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      autosize: { minRows: 8, maxRows: 16 },
                      placeholder: "请输入VIP等级规则说明",
                    },
                    model: {
                      value: _vm.vipRuleDescForm.desc,
                      callback: function ($$v) {
                        _vm.$set(_vm.vipRuleDescForm, "desc", $$v)
                      },
                      expression: "vipRuleDescForm.desc",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.vipRuleDescDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.handleVipRuleDescSubmit },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }